import "./HomePage.scss";
import HeroCarousel from "../../components/Hero/HeroCarousel.js";
import MidHome from "../../components/MidHome/MidHome.js";

function HomePage() {
  return (
    <>
      <div className="home">
        <div>
          <HeroCarousel />
        </div>
        <MidHome />
      </div>
    </>
  );
}

export default HomePage;
